// src/helpers/sessionUtils.js OR src/utils/sessionUtils.js

import { toast } from 'react-toastify';
import axios from 'axios';

const SESSION_DURATION_MS = 180 * 24 * 60 * 60 * 1000;
const SESSION_STORAGE_KEY = 'userSessionData';

const TWOFACTOR_API_KEY = process.env.REACT_APP_2FACTOR_API_KEY;

/*export const setSessionWithExpiry = (userData) => {
    const now = Date.now();
    const sessionData = {
        user: userData,
        expiry: now + SESSION_DURATION_MS,
    };
    try {
        localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
        console.log("Session set. Expires at:", new Date(sessionData.expiry));
    } catch (e) {
        console.error("Error saving session to localStorage:", e);
    }
};*/

export const setSessionWithExpiry = (userData) => {
  const now = Date.now();
  const rawUser = userData?.user?.user || userData?.user || userData || null;
  const token = userData?.token || userData?.user?.token || rawUser?.token || null;
  const accountType = userData?.accountType || rawUser?.accountType ||
    ((userData?.isVisitor || rawUser?.isVisitor) ? 'visitor' : 'vendor');
  const normalizedUser = rawUser ? {
    ...rawUser,
    accountType,
    isVisitor: accountType === 'visitor',
    isVendor: accountType === 'vendor',
  } : null;
  const sessionData = {
    user: normalizedUser,
    token,
    accountType,
    expiry: now + SESSION_DURATION_MS,
  };
  try {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
    if (token) {
      localStorage.setItem('authToken', token);
      localStorage.setItem('token', token);
    }
    if (normalizedUser) {
      if (accountType === 'visitor') {
        localStorage.setItem('visitorUser', JSON.stringify(normalizedUser));
        localStorage.removeItem('userInfo');
      } else {
        localStorage.setItem('userInfo', JSON.stringify(normalizedUser));
        localStorage.removeItem('visitorUser');
      }
    }
  } catch (e) {
    console.error("Error saving session to localStorage:", e);
  }
};



export const getValidSession = () => {
    const itemStr = localStorage.getItem(SESSION_STORAGE_KEY);
    if (!itemStr) return null;

    try {
        const item = JSON.parse(itemStr);
        const now = Date.now();

        if (now > item.expiry) {
            localStorage.removeItem(SESSION_STORAGE_KEY);
            console.log("Session expired. Removed from storage.");
            return null;
        }

        const rawUser = item.user?.user || item.user;
        if (!rawUser) return item;
        const accountType = item.accountType || rawUser.accountType ||
            (rawUser.isVisitor ? 'visitor' : 'vendor');
        return {
            ...item,
            accountType,
            user: {
                ...rawUser,
                accountType,
                isVisitor: accountType === 'visitor',
                isVendor: accountType === 'vendor',
            }
        };

    } catch (e) {
        console.error("Error parsing session data from localStorage:", e);
        localStorage.removeItem(SESSION_STORAGE_KEY);
        return null;
    }
};



export const clearSession = () => {
    localStorage.removeItem(SESSION_STORAGE_KEY);
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('visitorUser');
    console.log('Session cleared from storage.');
};


// sessionUtils.js
export const clearAll = () => {
  // Clear local/session storage via existing clearSession
  clearSession();
  // Clear Cache Storage if supported (service workers, etc.)
  if (typeof caches !== 'undefined' && caches.keys) {
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name).catch((e) => console.error('Failed to delete cache', name, e));
      }
    }).catch((e) => console.error('Error enumerating caches', e));
  }
  console.log('All browser storage cleared (local, session, caches)');
};


export const sendOtp = async (mobileNumberWithCountryCode, templateName = 'Mangoloops+OTP') => {
    if (!TWOFACTOR_API_KEY) {
        console.error("OTP Service API Key (REACT_APP_2FACTOR_API_KEY) is missing in environment variables.");
        toast.error("OTP service configuration error. Cannot send OTP.", { autoClose: false });
        return { success: false };
    }
    if (!mobileNumberWithCountryCode) {
         toast.error("Mobile number is required to send OTP.", { autoClose: 4000 });
         return { success: false };
    }

    // Ensure number starts without '+' for 2Factor API call
    const numberForApi = mobileNumberWithCountryCode.startsWith('+')
        ? mobileNumberWithCountryCode.substring(1)
        : mobileNumberWithCountryCode;

    const otpSendUrl = `https://2factor.in/API/V1/${TWOFACTOR_API_KEY}/SMS/${numberForApi}/AUTOGEN/${templateName}`;

    console.log("Attempting to send OTP to 2Factor.in...");
    try {
        const response = await axios.get(otpSendUrl);
        console.log("2Factor.in Send OTP Response:", response.data);

        if (response.data?.Status === 'Success') {
            toast.success("OTP sent successfully!", { autoClose: 3000 });
            return { success: true, sessionId: response.data.Details };
        } else {
            const errorMessage = response.data?.Details || "Failed to send OTP.";
            toast.error(errorMessage, { autoClose: 5000 });
            console.error("2Factor.in Send OTP Error:", errorMessage);
            return { success: false };
        }
    } catch (error) {
        console.error("Error sending OTP via 2Factor.in:", error);
        let errorMessage = "Failed to send OTP due to a network or server issue.";
         if (error.response) {
             console.error("2Factor Send Error Data:", error.response.data);
             errorMessage = `OTP service error (${error.response.status}). Please try again later.`;
         } else if (error.request) {
             errorMessage = "Could not reach OTP service. Check connection.";
         }
        toast.error(errorMessage, { autoClose: 5000 });
        return { success: false };
    }
};
